export const SURVEY_DATA_VIEWER_MODAL_TITLE = 'Survey Data Viewer';

export const SURVEY_DATA_VIEWER_PATH = '/survey-data-viewer';
